interface Props {
  children: JSX.Element | JSX.Element[];
}

export default function Layout({ children }: Props) {
  return <div className="bg-platzi-dark-second border rounded border-cyan-900">{children}</div>;
}
